<template>
  <div>
    <div class="row" style="margin-top: 10px">
      <div class="col col-md-12 col-sm-12">
        <div style="margin-top: 20px">
          <h5 v-if="itens.length == 0" class="text-center text-secondary" style="margin-top: 30px">
            Nenhuma chave registrada
          </h5>
          <div v-for="(item) in itens" :key="item._id" :item="item" class="list-group-item p-2 pl-2 pr-2">
            <div class="row">
              <div class="col col-md-12 col-sm-12">
                <div class="d-flex justify-content-between">
                  <p class="
                      text-secondary mb-0
                    ">
                    <small>{{ formatDate(item.data) }} - {{ item.tipo == "EMAIL_PIX" ? "PIX" : item.tipo == "TEMP_ID" ? "TEMP" : item.tipo }}</small>                    
                  </p>
                  <button
                      type="button"
                      class="btn btn-danger btn-sm"
                      style="margin-left: 5px; color:white; zoom:0.8;"
                      title="Remover"
                      @click="excluir(item)"
                    > 
                      Remover
                    </button>
                </div>
                <div class="text-center mt-1">
                  <div class="d-flex justify-content-start">
                    <h6 class="mb-1" style="display: block">
                      {{ item.regexNome }}
                    </h6>
                  </div>
                  <div class="d-flex justify-content-between">
                    <h6 class="text-secondary" style="display: block;">
                      {{ item.regexTipo }}: {{ item.regexTipo.toUpperCase() == "CNPJ" ? item.regexCnpj : item.regexCpf }}
                    </h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { api } from "@/services/api.js";
import util from "../includes/util.js";

//import Combo from "../components/Combo.vue";

export default {
  name: "ListPayUsuario",
  components: {},
  props: {
    propView: { type: String, default: "completo" },
    usuario: { type: String, default: "" },
    site: { type: String, default: "" },
  },
  computed: {

  },
  methods: {
    async carregarItens() {
      this.itens = [];

      if (this.filtroUsuario == "") {
        return;
      }

      const response = await api.get(
        "/pp/usuario/" + this.filtroUsuario
      );
      var responseResult = response.data;
      if (!responseResult.erro) {
        this.itens = responseResult.itens;
      }
    },
    formatDate(data) {
      return util.formatDateTime(data);
    },
    async excluir(item) {
      if (confirm("Deseja excluir o item ?")) {
        
        const responseItem = await api.post("/pp/usuario/excluir/" + item._id, {});
        
        api.valid(responseItem.data, this.$router);

        if (!responseItem.data.erro) {          
            this.carregarItens();      
        }
      }
    },
  },
  mounted() {

  },
  data: function () {
    return {
      itens: [],
      filtroUsuario: ""
    };
  },
};
</script>

<style></style>
